export default "__VITE_ASSET__C6ubPdn4__"